export default __webpack_public_path__ + "static/media/legend-theme.b9e9553a.png";